// extracted by mini-css-extract-plugin
module.exports = {"draggable":"styles_draggable__YWsqD","dragging":"styles_dragging__6T_Oj"};